import './style.scss';

const setSlideInteractive = (slide, isActive) => {
  slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

  if (isActive) {
    slide.removeAttribute('inert');
  } else {
    slide.setAttribute('inert', '');
  }

  slide.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
    if (isActive) {
      if (element.dataset.workRelatedTabindex !== undefined) {
        const originalTabindex = element.dataset.workRelatedTabindex;

        if (originalTabindex === '') {
          element.removeAttribute('tabindex');
        } else {
          element.setAttribute('tabindex', originalTabindex);
        }

        delete element.dataset.workRelatedTabindex;
      }

      return;
    }

    if (element.dataset.workRelatedTabindex === undefined) {
      element.dataset.workRelatedTabindex = element.getAttribute('tabindex') ?? '';
    }

    element.setAttribute('tabindex', '-1');
  });
};

const updateSlideAccessibility = (swiper, status, announce = true) => {
  swiper.slides.forEach((slide, index) => {
    setSlideInteractive(slide, index === swiper.activeIndex);
  });

  if (status && announce) {
    status.textContent = `Project ${swiper.realIndex + 1} of ${swiper.slides.length}`;
  }
};

const initWorkSingleRelatedProjects = (section) => {
  if (section.dataset.workSingleRelatedProjectsInitialized === 'true') {
    return;
  }

  const slider = section.querySelector('[data-work-related-slider]');
  const slides = Array.from(section.querySelectorAll('[data-work-related-slide]'));
  const prev = section.querySelector('[data-work-related-prev]');
  const next = section.querySelector('[data-work-related-next]');
  const status = section.querySelector('[data-work-related-status]');
  const {Swiper, SwiperModules} = window.rebredgVendors || {};
  const {
    A11y,
    EffectFade,
    Keyboard,
    Navigation,
  } = SwiperModules || {};

  if (
    !slider
    || slides.length < 2
    || !prev
    || !next
    || !Swiper
    || !A11y
    || !EffectFade
    || !Keyboard
    || !Navigation
  ) {
    return;
  }

  section.dataset.workSingleRelatedProjectsInitialized = 'true';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const defaultSpeed = 650;

  const swiper = new Swiper(slider, {
    modules: [Navigation, A11y, Keyboard, EffectFade],
    slidesPerView: 1,
    spaceBetween: 0,
    speed: reducedMotion.matches ? 0 : defaultSpeed,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    simulateTouch: true,
    allowTouchMove: true,
    grabCursor: true,
    threshold: 8,
    watchSlidesProgress: true,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
      pageUpDown: false,
    },
    navigation: {
      prevEl: prev,
      nextEl: next,
      disabledClass: 'is-disabled',
      lockClass: 'is-locked',
    },
    a11y: {
      enabled: true,
      prevSlideMessage: 'Previous related project',
      nextSlideMessage: 'Next related project',
      firstSlideMessage: 'This is the first related project',
      lastSlideMessage: 'This is the last related project',
      slideLabelMessage: '{{index}} of {{slidesLength}}',
    },
    on: {
      init(instance) {
        updateSlideAccessibility(instance, status, false);
      },
      slideChange(instance) {
        updateSlideAccessibility(instance, status);
      },
    },
  });

  const handleReducedMotionChange = (event) => {
    swiper.params.speed = event.matches ? 0 : defaultSpeed;
  };

  if (typeof reducedMotion.addEventListener === 'function') {
    reducedMotion.addEventListener('change', handleReducedMotionChange);
  } else if (typeof reducedMotion.addListener === 'function') {
    reducedMotion.addListener(handleReducedMotionChange);
  }
};

export function work_single_related_projects(root = document) {
  const selector = '[data-component="work-single-related-projects"]';
  const context = root || document;
  const sections = [];

  if (context.nodeType === 1 && context.matches?.(selector)) {
    sections.push(context);
  }

  if (context.querySelectorAll) {
    sections.push(...context.querySelectorAll(selector));
  }

  sections.forEach(initWorkSingleRelatedProjects);
}
